import { ClockIcon } from '@assets/icons';
import Typography from '@components/Typography';
import Tooltip from '@components/ui/Tooltip/next';
import CustomIcon from '@components/utils/CustomIcon';
import { useDevice } from '@contexts/device';
import palette from '@utils/theme/palette';
import { secondsToMinutesAndSeconds } from '@utils/utils';

import { TimerContainer } from '../SummaryCardStyle';

const TimerTooltip = ({ timeRemaining }: { timeRemaining: number }) => {
  const { isDesktop } = useDevice();
  return (
    <Tooltip
      overlayInnerStyle={{
        textAlign: 'center',
        width: '210px',
        backgroundColor: palette.NL0,
        padding: '8px',
      }}
      arrowColor={palette.NL0}
      overlayStyle={{
        backgroundColor: palette.NL0,
        borderRadius: '8px',
      }}
      placement={isDesktop ? 'top' : 'topRight'}
      title={
        <Typography variant='caption2' color='D500' weight='Light'>
          Rezervasyonu tamamlama süreniz
        </Typography>
      }
      getPopupContainer={(node) => node}
    >
      <TimerContainer>
        <CustomIcon icon={ClockIcon} fontSize={22} paletteColor='R400' />
        <Typography variant='Title5' color='R400' weight='SemiBold'>
          {timeRemaining > 0
            ? secondsToMinutesAndSeconds(timeRemaining)
            : '00:00'}
        </Typography>
      </TimerContainer>
    </Tooltip>
  );
};

export default TimerTooltip;
